import { runClientComponent } from '../../_common/client/client-component-runner';
import { CompetingOffersComponent } from './competing-offers.component';

runClientComponent({ CompetingOffersComponent: CompetingOffersComponent });
